import {
	GET_SIMULATE_EHR_LIST_REQUEST,
	GET_SIMULATE_EHR_LIST_SUCCESS,
	GET_SIMULATE_EHR_LIST_ERROR,
	GET_SIMULATE_EHR_LIST_RESET,
} from '../actions/getSimulateEhrListAction';

const initialState = {
	apiState: '',
	data: null,
	error: null,
};

const getSimulateEhrListReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_SIMULATE_EHR_LIST_REQUEST:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_SIMULATE_EHR_LIST_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.payload,
				error: null,
			};
		case GET_SIMULATE_EHR_LIST_ERROR:
			return {
				...state,
				apiState: 'error',
				error: action.payload,
			};
		case GET_SIMULATE_EHR_LIST_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getSimulateEhrListReducer; 